import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-allotmentdigital',
  providers: [AnimationService, RouteDirections],
  templateUrl: './allotment-digital.component.html',
  styleUrls: ['./allotment-digital.component.css'],
  animations: [AnimationsMetaData]
})
export class AllotmentDigitalComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.allotmentdigital;
  }

  ngOnInit() {
    this.Title.setTitle('Allotment Digital - Work | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'Allotment Digital was a marketing consultancy and product business. We designed and built several pieces of technology to make life easier for SEOs, and worked with some of the UKs biggest retailers to improve the way they implemented campaigns.'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/work/allotment-digital/allotment-digital.component.ts